import { AiCoach_Action } from '__generated__/graphql-types';

/** The "coach" item type is being used to render "Dialogue" and "Role Play", hence these const, serve as

 an override to the "coach" typename to create a distinction between the two experiences of the same item type. */
export const COACH_ITEM_TYPENAME_OVERRIDE = {
  DIALOGUE: 'Dialogue',
  ROLE_PLAY: 'Role Play',
} as const;

export type CoachItemTypeOverride = (typeof COACH_ITEM_TYPENAME_OVERRIDE)[keyof typeof COACH_ITEM_TYPENAME_OVERRIDE];

/** The unique name of the plugin as set in the "name" property of the manifest file */
export const SOCRATIC_DIALOGUE_PLUGIN_NAME = 'coursera.coachItem.socraticDialogue';
export const ROLE_PLAY_PLUGIN_NAME = 'coursera.coachItem.rolePlay';

export const CHAT_INITIALIZING_MAGIC_STRING = "I'm ready to start";
export const HOW_AM_I_DOING_MAGIC_STRING = 'How am I doing?';
export const CHAT_STUCK_MAGIC_STRING = "I'm stuck";
export const GENERATE_SCENARIO_MAGIC_STRING = 'Generate Scenario';
export const GENERATE_JSON_MAGIC_STRING = 'Generate JSON';
export const GENERATE_FEEDBACK_MAGIC_STRING = 'Generate Feedback';
export const GENERATE_HINT_MAGIC_STRING = 'Give me a hint';
export const GENERATE_SUMMARY_MAGIC_STRING = 'Generate final session summary';
export const GENERATE_TASK_MAGIC_STRING = 'task';
/**
 * Marker string returned inside the Role Play intro Scenario JSON response message.
 */
export const ROLE_PLAY_SCENARIO_JSON_MARKER = 'Final_Scenario_Output';
export const DEFAULT_COACH_ITEM_STUCK_END_MESSAGE = 'Reason not provided';
export const ROLE_PLAY_END_SESSION_MESSAGE = 'Chat session ended by user';

export const HINT_COACH_ACTION_ID = 'ASK_FOR_HINT';
export const FIRST_HINT_COACH_ACTION_ID = 'ASK_FOR_FIRST_HINT';
export const ROLE_PLAY_COACH_MODE_ID = 'COACH_ITEM_ROLE_PLAY';
export const COACH_ITEM_TYPED_MESSAGE_ACTION_ID = 'COACH_ITEM_TYPED_MESSAGE';

export const TASK_LISTING_COACH_ACTION_ID = 'TASK_LISTING';
export const TASK_TRACKING_COACH_ACTION_ID = 'TASK_TRACKING';

/** The current live version of the prompt */
export const CURRENT_SOCRATIC_DIALOGUE_PROMPT_VERSION = 3;

export const CURRENT_ROLE_PLAY_PROMPT_VERSION = 1;

export const SUPPORTED_ASSET_FILETYPES = ['.txt', 'text/plain'];

export const CHAT_MESSAGES_CONTAINER_MAX_WIDTH = 600;

export const LEARNER_PENDO_ID = 'coach-item-provide-feedback-button-learner';
export const ROLE_PLAY_PENDO_ID = 'role-play-provide-feedback-button-learner';

export const ROLE_PLAY_TASK_REQUIRED_COUNT = 2;

export const ROLE_PLAY_TASK_MAX_COUNT = 5;

/** Used when the coach item context does not supply a passing fraction. */
export const FALLBACK_PASSING_FRACTION = 1;

export const COACH_ITEM_AUTHORING_CONTEXT_KEY = 'additionalContext.coachItem.authoring';

export const COACH_ITEM_CHAT_SESSION_CONTEXT_KEY = 'additionalContext.chatSessionId';

export const RolePlayModality = {
  TEXT: 'text',
  VOICE: 'voice',
} as const;

/**
 * In Coach Platform, an action can be any arbitrary string, and we can no longer rely on
 * AiCoach_Action to contain all the possible actions. Extend AiACoach_Action with action IDs
 * that we need.
 */
export const CoachPlatformActionIdMap = {
  ...AiCoach_Action,
  CoachItemGenerateScenarioV2: 'COACH_ITEM_GENERATE_SCENARIO_V2',
} as const;
